import { init } from '@plausible-analytics/tracker'
import './src/styles/global.css'

init({
  domain: 'ytdowns.net',
  endpoint: 'https://pb.ytmp3tube.com/api/event'
})